// extracted by mini-css-extract-plugin
var _1 = "ra-artist-comment-author";
var _2 = "ra-artist-comment-author-dash";
var _3 = "ra-artist-comment";
var _4 = "ra-artist-comment-large";
var _5 = "ra-artist-comment-medium";
var _6 = "ra-artist-comment-small";
export { _1 as "artistCommentAuthorCls", _2 as "artistCommentAuthorDashCls", _3 as "artistCommentCls", _4 as "artistCommentLargeCls", _5 as "artistCommentMediumCls", _6 as "artistCommentSmallCls" }
